// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31lvE","rightAdornment":"Header_rightAdornment__3m4ow"};